// React
import PropTypes from "prop-types";
import { useMemo, useState } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tab, Tabs, Tooltip } from "@mui/material";

// UI components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";

// Utils
import { makeNiceText } from "utils/formatters";
import PresupuestosTab from "./PresupuestosTab";
import FacturaTab from "./FacturaTab";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "95%", sm: "85%", md: "75%", xxl: "70%" },
  overflowY: "auto",
  p: 3,
};

export default function DetallesEvento({ open, handleClose, selectedEvento }) {
  const [activeTab, setActiveTab] = useState(0);

  const estadoBadge = useMemo(() => {
    const estado = selectedEvento?.estado;
    const color =
      estado === "Confirmado"
        ? "uproGreen"
        : estado === "Pendiente"
        ? "uproYellow"
        : estado === "Cancelado"
        ? "uproPink"
        : "secondary";
    return <SoftBadge color={color} badgeContent={makeNiceText(estado) || "-"} />;
  }, [selectedEvento]);

  return (
    <Modal
      aria-labelledby="modal-detalles-evento"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Detalles del evento</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            {/* Resumen del evento */}
            <SoftBox mt={2} px={1}>
              <SoftBox
                display={{ xs: "block", sm: "flex" }}
                justifyContent="space-between"
                alignItems="center"
                gap={2}
              >
                <SoftBox>
                  <SoftTypography variant="caption" color="text">
                    ID
                  </SoftTypography>
                  <SoftTypography variant="h6">{selectedEvento?.id || "-"}</SoftTypography>
                </SoftBox>
                <SoftBox>
                  <SoftTypography variant="caption" color="text">
                    Cliente
                  </SoftTypography>
                  <SoftTypography variant="h6">
                    {selectedEvento?.clienteEvento?.nombre || selectedEvento?.clienteEvento?.razonSocial || "-"}
                  </SoftTypography>
                </SoftBox>
                <SoftBox>
                  <SoftTypography variant="caption" color="text">
                    Fecha
                  </SoftTypography>
                  <SoftTypography variant="h6">{selectedEvento?.fechaEvento || "-"}</SoftTypography>
                </SoftBox>
                <SoftBox>
                  <SoftTypography variant="caption" color="text">
                    Estado
                  </SoftTypography>
                  <SoftBox mt={0.5}>{estadoBadge}</SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            {/* Tabs */}
            <SoftBox mt={3}>
              <Tabs value={activeTab} onChange={(e, value) => setActiveTab(value)}>
                <Tab label="Presupuestos" />
                <Tab label="Facturas" />
              </Tabs>
              <SoftBox mt={2}>
                {activeTab === 0 && (
                  <PresupuestosTab idEvento={selectedEvento?.id} />
                )}
                {activeTab === 1 && (
                  <SoftBox>
                    <FacturaTab idEvento={selectedEvento?.id} />
                  </SoftBox>
                )}
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

DetallesEvento.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedEvento: PropTypes.object,
};
